import { css } from "@emotion/core";
import { color } from "../../constants/commons";

export const feeStructurePageStyle = css`
  .fee-structure-container {
    max-width: 100em;
    margin: auto;
    background: linear-gradient(
      -153.43494882292202deg,
      rgb(242, 244, 248) 0%,
      rgb(255, 255, 255) 100%
    );
    border-radius: 0em;
  }

  img {
    margin-right: 1em;
  }
  .back-button {
    margin-right: 0.5em;
  }
  .back-button-style {
    color: ${color.red};
    height: 1.35em;
  }

  /* Extra small devices (portrait phones, less than 576px) */
  @media (max-width: 575.98px) {
    .fee-structure-body {
      background: ${color.whitishGray};
      border-radius: 0.375em;
      box-shadow: 0em 0.25em 0.625em 0em ${color.shadow};
      padding: 1em;
      width: 100%;
      margin-bottom: 1em;
    }
    .single-section {
      padding-top: 5em;
    }
  }
  /* Small devices (landscape phones, 576px and up) */
  @media (min-width: 576px) and (max-width: 767.98px) {
    .fee-structure-body {
      background: ${color.whitishGray};
      border-radius: 0.375em;
      box-shadow: 0em 0.25em 0.625em 0em ${color.shadow};
      padding: 2em;
      width: 100%;
      margin-right: 1em;
    }
    .single-section {
      padding-top: 5em;
    }
  }
  /* Medium devices (tablets, 768px and up) */
  @media (min-width: 768px) and (max-width: 991.98px) {
    .single-section {
      padding-top: 5em;
    }
    .fee-structure-body {
      background: ${color.whitishGray};
      border-radius: 0.375em;
      box-shadow: 0em 0.25em 0.625em 0em ${color.shadow};
      padding: 2em;
      width: 100%;
      margin-right: 1em;
    }
  }
  /* Large devices (desktops, 992px and up) */
  @media (min-width: 992px) and (max-width: 1199.98px) {
    .fee-structure-body {
      background: ${color.whitishGray};
      border-radius: 0.375em;
      box-shadow: 0em 0.25em 0.625em 0em ${color.shadow};
      padding: 2em;
      width: 100%;
      margin-right: 1em;
    }
    .single-section {
      padding-top: 5em;
    }
  }
  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) {
    .fee-structure-body {
      background: ${color.whitishGray};
      border-radius: 0.375em;
      box-shadow: 0em 0.25em 0.625em 0em ${color.shadow};
      padding: 2em;
      width: 100%;
      margin-right: 1em;
    }
    .single-section {
      padding-top: 5em;
    }
  }
`;
